import React from 'react';
import { connect } from 'react-redux';
import { fetchDataIfNeeded, invalidateDbReportData } from '../../actions/dbreport/ItemsAction';
import BigBreadcrumbs from '../../components/layout/navigation/components/BigBreadcrumbs.jsx'
import WidgetGrid from '../../components/layout/widgets/WidgetGrid.jsx'
import JarvisWidget from '../../components/layout/widgets/JarvisWidget.jsx'
import Widget from '../../components/layout/widgets/SCWidget.jsx'
import Datatable from '../../components/tables/Datatable.jsx'
import TableHeader from '../../components/tables/TableHeader.jsx'
import ChartJsGraph from '../../components/graphs/chartjs/ChartJsGraph.jsx'

class ItemUniqueRegister extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isActivityUser: this.props.isActivityUser,
      year: '0',
      categoryId: '0',
      epark: 1
    };

    this.onChangeActivityUser = this.onChangeActivityUser.bind(this);
    this.onChangeTableHeader = this.onChangeTableHeader.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(fetchDataIfNeeded(this.state));
  }

  onChangeTableHeader(year, categoryId) {
      console.log(`year:${year}   categoryId:${categoryId}`);
      this.setState({
        year, categoryId
      });

      let searchOption = Object.assign({}, this.state, {
          year, categoryId
        });

      this.props.dispatch(invalidateDbReportData());
      this.props.dispatch(fetchDataIfNeeded(searchOption));
  }

  onChangeActivityUser(isActivityUser){

    this.setState({
      isActivityUser
    });

    let searchOption = Object.assign({}, this.state, {
          isActivityUser
        });

    this.props.dispatch(invalidateDbReportData());
    this.props.dispatch(fetchDataIfNeeded(searchOption));

  }

  render() {

    return <div id="content">
                <div className="row">
                    <BigBreadcrumbs items={['Table', 'Data Tables']} icon="table"
                                    className="col-xs-12 col-sm-7 col-md-7 col-lg-4"/>
                </div>

                <WidgetGrid>

                    <div className="row">
                        <article className="col-sm-6">
                            <Widget title="カード登録" isActivityUser={this.state.isActivityUser} handleActivityUserChange={this.onChangeActivityUser}>
                                <TableHeader onChange={this.onChangeTableHeader} />
                                <Datatable
                                    data = {this.props.data}
                                    options={{
                                        "order": [[ 0, 'desc' ]],
                                        columns: [
                                            {data: "yymm"},
                                            {data: "register_cnt"},
                                            {data: "all_reg_cnt"}
                                        ],
                                        buttons: [
                                            {
                                                extend: 'csv',
                                                bom: true
                                            }, 
                                            'copy', 'excel', 'pdf'
                                        ],
                                        "pageLength": 20
                                    }}
                                    className="table table-striped table-bordered table-hover"
                                    width="100%">
                                    <thead>
                                    <tr>
                                        <th >年月</th>
                                        <th >登録数</th>
                                        <th >累計登録数</th>
                                    </tr>
                                    </thead>
                                </Datatable>
                            </Widget>
                        </article>

                        <article className="col-sm-6">

                          <JarvisWidget editbutton={false}>
                              <header>
                                  <span className="widget-icon"> <i className="fa fa-bar-chart-o"/> </span>
                                  <h2>Chart</h2>
                              </header>
                              <div>
                                  <div className="widget-body">
                                      <ChartJsGraph type="line" data={this.props.graphData} />
                                  </div>
                              </div>
                          </JarvisWidget>
                        </article>

                    </div>

                </WidgetGrid>
            </div>
  }
}

const mapStateToProps = (state) => {

  const { itemRegister } = state;
  const { isActivityUser, isFetching } = itemRegister;

  if(!isFetching){

    return {
      data: itemRegister.data,
      graphData: {
          labels: itemRegister.data.map((val) => val.yymm),
          datasets:[{
              label: "カード登録数",
              borderColor: "#e7711b",
              borderWidth: 2,
              data: itemRegister.data.map((val) => val.register_cnt),
              fill: true,
              lineTension: 0
          }, {
              label: "カード登録累計",
              borderColor: "#1c91c0",
              borderWidth: 2,
              data: itemRegister.data.map((val) => val.all_reg_cnt),
              fill: true,
              lineTension: 0
          }]
      },
      isFetching: isFetching,
      isActivityUser: isActivityUser
    }
  }else{
    return {}
  }
}

export default connect(mapStateToProps)(ItemUniqueRegister);


// WEBPACK FOOTER //
// ./src/pages/dbreport/ItemEparkRegister.js